"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectProvider = exports.useSelectCtx = void 0;
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importStar(require("react"));
/** Select 中传递信息的 context，包含当前值及选中操作的回调等信息 */
var selectCtx = react_1.createContext({
    selected: [],
    onSelect: function () { return undefined; },
    multiple: false,
    size: 'default'
});
function useSelectCtx() {
    return react_1.useContext(selectCtx);
}
exports.useSelectCtx = useSelectCtx;
function SelectProvider(_a) {
    var value = _a.value, children = _a.children;
    return react_1.default.createElement(selectCtx.Provider, { value: value }, children);
}
exports.SelectProvider = SelectProvider;
//# sourceMappingURL=context.js.map